export default {"src":"/_next/static/media/credit_mantri.675a8c58.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};